import React from 'react';
import {createGUID} from '../../../util/utility';
import {CoveragesItem} from '../Coverages';
import CoveragesListItem from './CoveragesListItem';
import '../styles.scss';
import {uriGetTopDetailV2Coverages} from '../../../api/endpoints';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {get} from '../../../api/api';

export interface CoveragesListProps {
  selectedBu: any;
  coveragesList: CoveragesItem[];
  setCoverageDetails?: any;
  setSelectedItem(value: CoveragesItem): void;
  setShowModal(value: boolean): void;
  setErrorFetchingDetail(value: boolean): void;
}

function CoveragesList({
  selectedBu,
  coveragesList,
  setCoverageDetails,
  setSelectedItem,
  setShowModal,
  setErrorFetchingDetail,
}: CoveragesListProps) {
  const handleDisplayCoverageDetails = async (
    element: CoveragesItem,
    e: React.MouseEvent
  ) => {
    e.preventDefault();
    await get(
      uriGetTopDetailV2Coverages(
        selectedBu.buId,
        selectedBu.benNbr,
        element.idReg
      )
    )
      .then((res: any) => {
        setCoverageDetails(res.data.items);
      })
      .catch(() => {
        setErrorFetchingDetail(true);
        setCoverageDetails([])
      })
      .finally(() => {
        setSelectedItem(element);
        setShowModal(true);
      });
  };

  return (
    <>
      {coveragesList?.map((element: CoveragesItem) => (
        <div
          key={createGUID()}
          onClick={(e) => handleDisplayCoverageDetails(element, e)}
          style={{cursor: 'pointer'}}>
          <CoveragesListItem
            key={createGUID()}
            coveragesItem={element}></CoveragesListItem>
        </div>
      ))}
    </>
  );
}
const mapStateToProps = ({selectedBu}: any) => ({
  selectedBu: selectedBu.value,
});

export default compose(connect(mapStateToProps)(CoveragesList));
